import { Convidados } from '../types/Presenca'

export const TIPOS_DE_CONVIDADOS = [
    {
        descricao: 'Adulto(s)',
        chave: 'adultos',
    },
    {
        descricao: 'Criança(s)',
        chave: 'criancas',
    },
] satisfies { descricao: string; chave: keyof Convidados }[]


export function formatarConvidados(convidados?: Convidados) {
    const convidadosFormatados = TIPOS_DE_CONVIDADOS
        .map(tipo => convidados?.[tipo.chave] && `${convidados[tipo.chave]} ${tipo.descricao}`)
        .filter(Boolean)
        .join(' e ') || '0 Convidados'
    return  `+${convidadosFormatados}`
}

export function temConvidados(convidados?: Convidados) {
    return convidados && TIPOS_DE_CONVIDADOS.some(tipo => convidados[tipo.chave]);
}

export function totalDeConvidados(convidados?: Convidados) {
    return convidados
        ? TIPOS_DE_CONVIDADOS.reduce((total, tipo) => total + convidados[tipo.chave], 0)
        : 0;
}